import bus from '~/bus'
import {useEventHelper} from '~/helpers/eventHelper'

export default {
  name: 'unshared',
  do: async function (payload) {
    console.log('DEBUG unshared: ', this, payload)
    const {getEventFile, actorIsSharer} = useEventHelper()

    if (this.file === payload.unsharer) {
      actorIsSharer(payload.unsharer).then(isSharer => {
        if (isSharer) {
          bus.$emit('deleteFile', payload.deprecated_file_id)
        } else {
          bus.$emit('showWarningAndRedirect', 'NoFilesSharedWarning')
        }
      }).catch(e => console.error(e))
    }
    if (this.file === 'shared') {
      bus.$emit('doBackgroundReload', 'unshared 1')
    }

    if ((this.fileChildren && this.fileChildren.includes(payload.parent_id))) {
      getEventFile(payload.deprecated_parent_id).then((response) => {
        bus.$emit('updateFile', response)
      })
    }
    let reachable = false
    let file = null
    await getEventFile(payload.deprecated_file_id).then(response => {
      file = response
      reachable = true
    }, reject => {
      // reachable = false
    }).catch(e => {
       // reachable = false
      console.error('getEventFile:', e)
    })
    if (reachable &&
      (this.file === payload.file_id || (this.file !== payload.parent_id && this.fileAncestors && this.fileAncestors.includes(payload.file_id)))) {
      bus.$emit('refreshAppbar', file) // only have sense for files shared with groups
      bus.$emit('refreshRightDrawerSharers')
      bus.$emit('refreshRightDrawer', file)
      bus.$emit('doBackgroundReload', 'unshared 2')
    }

    if (reachable && this.fileChildren && this.fileChildren.includes(payload.file_id)) {
      bus.$emit('updateFile', file)
      bus.$emit('refreshRightDrawer', file)
      bus.$emit('refreshRightDrawerSharers', file)
    }

    if (!reachable && ((this.file === 'recent' && payload.recent) || this.file === payload.parent_id || (this.fileChildren && this.fileChildren.includes(payload.file_id)))) {
      bus.$emit('deleteFile', payload.deprecated_file_id)
    }

    if (!reachable && this.file === payload.file_id) {
      bus.$emit('showWarningAndRedirect')
    }

    if (!reachable && this.fileAncestors && this.fileAncestors.includes(payload.file_id)) {
      let childReachable = false
      let child = null
      await getEventFile(payload.deprecated_file_id).then(response => {
        child = response
        childReachable = true
      }, reject => {
         // childReachable = false
      }).catch(e => {
         // childReachable = false
        console.error('getEventFile:', e)
      })
      if (!childReachable) {
        bus.$emit('showWarningAndRedirect')
      } else {
        bus.$emit('refreshAppbar', child)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/events/unshared.js